module.exports = __webpack_public_path__ + "media/images/front/treatment_support/img_tutorial_01-e3ed0fb1a21d66679ec921ae369c0b7a.png";